export interface JobRequirementContact {
  name: string;
  email: string;
  phoneNumber: string;
  shift: number;
  description: string;
}
